/**
 * Signed-in account surfaces that share the dashboard top nav chrome
 * (logo + theme toggle — no marketing link row).
 */
export function isAccountAppRoute(pathname: string): boolean {
  return (
    pathname === "/dashboard" ||
    pathname === "/properties" ||
    pathname === "/team" ||
    pathname.startsWith("/compare/lots")
  );
}
